import { Directive, HostBinding, Input } from '@angular/core'
import { ButtonBasicColors, ButtonBasicSizes } from '../../../models/button.interfaces'

@Directive({
    selector: '[appButtonBasic]'
})
export class ButtonBasicDirective {
    @Input() color: ButtonBasicColors = 'primary'
    @Input() size: ButtonBasicSizes = 'small'
    @Input() hoverEffect: boolean = true
    @Input() vertical: boolean = false

    @HostBinding('class.hoverEffect') get buttonHoverEffect(): boolean {
        return this.hoverEffect
    }

    @HostBinding('class.app-button-vertical') get buttonVertical(): boolean {
        return this.vertical
    }

    @HostBinding('class') get buttonClass(): string {
        return `app-button-basic app-button-basic-${this.color} app-button-basic-${this.size}`
    }
}
